// src/pages/ClaimDossier/modals/DossierDecisionModal.tsx
// README.md muc 9 — popup dung chung cho "Thẩm định" va "Hậu kiểm" ho so do dai ly tu tao (2 quyet
// dinh: Phe duyet / Tu choi, bat buoc ghi chu khi Tu choi) — mirror ReasonPromptModal (Components/Common)
// nhung co 2 nut ket qua thay vi 1.

import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ClaimDossierReviewDecision } from '../types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('claim_dossier');

interface DossierDecisionModalProps {
  isOpen: boolean;
  title: string;
  submitting?: boolean;
  onSubmit: (decision: ClaimDossierReviewDecision, comment?: string) => void | Promise<void>;
  onCancel: () => void;
}

const DossierDecisionModal: React.FC<DossierDecisionModalProps> = ({
  isOpen,
  title,
  submitting = false,
  onSubmit,
  onCancel,
}) => {
  const [comment, setComment] = useState('');
  const [pendingDecision, setPendingDecision] = useState<ClaimDossierReviewDecision | null>(null);

  useEffect(() => {
    if (isOpen) {
      setComment('');
      setPendingDecision(null);
    }
  }, [isOpen]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!pendingDecision) return;
    if (pendingDecision === 'TuChoi' && comment.trim().length < 5) return;
    onSubmit(pendingDecision, comment.trim() || undefined);
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel} centered>
      <ModalHeader className="bg-light p-3" toggle={onCancel}>
        {title}
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label>{st('ghi_chu_text')} {pendingDecision === 'TuChoi' && <span className="text-danger">*</span>}</Label>
            <Input
              type="textarea"
              rows={4}
              required={pendingDecision === 'TuChoi'}
              minLength={pendingDecision === 'TuChoi' ? 5 : undefined}
              value={comment}
              placeholder={st('bat_buoc_nhap_neu_tu_choi_placeholder')}
              onChange={(event) => setComment(event.target.value)}
              autoFocus
            />
          </FormGroup>
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <Button color="light" onClick={onCancel} disabled={submitting}>
              {st('dong_button')}
            </Button>
            <Button
              color="danger"
              outline
              type="submit"
              disabled={submitting}
              onClick={() => setPendingDecision('TuChoi')}
            >
              {submitting && pendingDecision === 'TuChoi' && (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              )}
              {st('tu_choi_button')}
            </Button>
            <Button
              color="success"
              type="submit"
              disabled={submitting}
              onClick={() => setPendingDecision('PheDuyet')}
            >
              {submitting && pendingDecision === 'PheDuyet' && (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              )}
              {st('phe_duyet_button')}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default DossierDecisionModal;
